import { QuestionRegulatoryData, Questionnaire, QuestionnaireQuestion, SupplierQuestionnaireData } from "../../Models/Surveys/SurveyDataModel";
import { RegulationManager } from "../RegulationManager";
import { ConflictMineralsV2CustomLogicManager } from "./ConflictMineralsV2CustomLogicManager";

export class ConflictMineralsV2SupplierQuestionnairCustomLogicManager extends ConflictMineralsV2CustomLogicManager {
    public static GenericRegulationId = RegulationManager.ConflictMineralsV2SupplierQuestionnaireRegulationId;

    private static readonly SURVEY_QUESTIONS = [
        'cmrt_3tg_added_or_used',
        'cmrt_3tg_remains',
        'cmrt_3tg_from_covered_countries',
        'cmrt_3tg_all_recycled',
        'cmrt_suppliers_response_rate',
        'cmrt_all_smelters_identified',
        'cmrt_smelter_info_received',
        'cmrt_conflict_affected_high_risk_areas',
        'cmrt_drc_conflict_free_policy',
        'cmrt_is_drc_conflict_free_policy_public',
        'cmrt_suppliers_must_use_cfs_smelters',
        'cmrt_due_diligence_for_cfs',
        'cmrt_conduct_conflict_minerals_survey',
        'cmrt_verify_suppliers_due_diligence',
        'cmrt_verification_includes_corrective_actions',
        'cmrt_subject_to_sec_cm_disclosure_rule',
        'cmrt_smelters_list',
        'cmrt_product_list',
        'cmrt_notes',
        'cmrt_general_files',
        'cmrt_response_date'
    ];

    protected getAdditionalQuestionIndicesToHide(question: QuestionnaireQuestion, questionIndex: number, indicesToHideOrShow: boolean[]) {
        for (let i = 0; i < this._questions.length; ++i) {
            indicesToHideOrShow[i] = this.shouldHideQuestion(this._questions[i], i)
        }

        return indicesToHideOrShow;
    }

    private shouldShowSurveyQuestions() {
        const declarationOfScope = this.getSupplierQuestionnaireDeclarationOfScope();
        return declarationOfScope?.toLowerCase() === "company";
    }

    protected shouldHideQuestion(question: QuestionnaireQuestion, questionIndex: number) {
        if (question.type.toLowerCase() === "section") {
            const isCompanyInfoSection = question.text.toLowerCase() === "company information";
            const shouldShowSurvey = this.shouldShowSurveyQuestions();
            
            return !(isCompanyInfoSection || shouldShowSurvey);
        }
    
        const fieldKey = question.summaryFieldKey;

        if (!this.shouldShowSurveyQuestions() && 
            fieldKey && 
            ConflictMineralsV2SupplierQuestionnairCustomLogicManager.SURVEY_QUESTIONS.includes(fieldKey)) {
            return true;
        }
        else
            return false;
    }

    public getPageRequiredInfoLocalized() {
        return null;
    }
}
